module.exports = __webpack_public_path__ + "static/media/39_Finance_Cell.710d2a46.JPG";